import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-investor-details',
  templateUrl: './investor-details.component.html',
  styleUrls: ['./investor-details.component.scss']
})
export class InvestorDetailsComponent implements OnInit {
// selectedInstallments: any[] = [];
// selectAll: boolean = false;
    productId: string | null = null;
  // investor: any = {
  //   name: '',
  //   email: '',
  //   phone: '',
  //   password: '',
  //   job_title_id: ''
  // };
  


  investor: any;
  contracts: any[] = [];

  selectedInstallments: any[] = [];
  selectAll: boolean = false;

  paymentData = {
    paid_amount: null as number | null,
      payment_date: '',
      payment_method: ''
  };

  selectedFile: File | null = null;


   employeeId: string | null = null;
  // contracts: any;
  currentLang: string;

constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApisService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) {}
    ngOnInit(): void {
       this.currentLang = localStorage.getItem('currentLang') || 'ar';
    // get product id from route
   this.employeeId = this.route.snapshot.paramMap.get('id');
    if (this.employeeId) {
      this.loadInvestor(this.employeeId);
    }


        
  }

onFileSelected(event: any) {
  if (event.target.files && event.target.files.length > 0) {
    this.selectedFile = event.target.files[0];
    console.log('File selected:', this.selectedFile);
  }
}
toggleInstallment(id: any) {

  const index = this.selectedInstallments.indexOf(id);

  if (index > -1) {
    this.selectedInstallments.splice(index, 1);
  } else {
    this.selectedInstallments.push(id);
  }

}
  isSelected(id: any): boolean {
  return this.selectedInstallments.includes(id);
}
toggleSelectAll() {

  if (this.selectAll) {

    this.selectedInstallments = this.contracts.map(
      (c: any) => c.next_installment?.id
    );

  } else {

    this.selectedInstallments = [];

  }

}
paySelected() {

  const formData = new FormData();

  this.selectedInstallments.forEach(id => {
    formData.append('installment_ids[]', id.toString());
  });

  formData.append('paid_amount', this.paymentData.paid_amount?.toString() || '');
  formData.append('payment_date', this.paymentData.payment_date);

  if (this.selectedFile) {
    formData.append('transfer_file', this.selectedFile);
  }

  this.apiService.addMultiPaidInstallments(formData)
    .subscribe({
      next: (res) => {
        console.log(res);
      },
      error: (err) => {
        console.error(err);
      }
    });

}
submitBulkPayment(modal: any) {
  const formData = new FormData();

  // Append selected installments
  this.selectedInstallments.forEach(id => {
    formData.append('installment_ids[]', id.toString());
  });

  // Append amount and date
  formData.append('paid_amount', this.paymentData.paid_amount?.toString() || '');
  formData.append('payment_date', this.paymentData.payment_date || '');
  formData.append('payment_method', this.paymentData.payment_method || '');

  // Append file - **must be not null**
  if (!this.selectedFile) {
    alert('Please select a transfer file');
    return;
  }
  formData.append('transfer_file', this.selectedFile, this.selectedFile.name);

  console.log('FormData before sending:');
  formData.forEach((v, k) => console.log(k, v));

  this.apiService.addMultiPaidInstallments(formData)
    .subscribe({
      next: () => {
        modal.close();
        this.selectedInstallments = [];
        this.paymentData.paid_amount = null;
        this.paymentData.payment_date = '';
        this.paymentData.payment_method = '';
        this.selectedFile = null;
        alert('Payment added successfully');
      },
      error: (err) => {
        console.error('Payment error:', err);
        const errorMessage = err.error?.message || 'Failed to submit payment. Please try again.';
        this.toastr.error(errorMessage);
      }
    });
}

openPaymentModal(content: any) {
  this.modalService.open(content, {
    centered: true,
    size: 'md'
  });
}

  loadInvestor(id: string): void {
    this.apiService.getInvestorById(id).subscribe({
      next: (res: any) => {
        this.investor = res?.data || {};
        this.contracts =  res?.data?.contracts || {}
        console.log( 'response from investor :',this.investor )
        console.log( 'response from contracts :',this.contracts )
      },
      error: (err) => {
        console.error('Failed to load investor:', err);
        this.toastr.error('Failed to load investor details');
      },
    });
  }

  contractDetailsById(contractsId: number) {
  this.router.navigate(['/contract-details', contractsId]);
}

getAmountFrom(inst: any): number {
  return Number(inst?.next_installment?.amount || 0);
}

getAmountTo(inst: any): number {
  return Number(inst?.next_installment?.amount_max || 0);
}
getAmountRatio(inst: any): number {
  const amount = Number(inst?.next_installment?.amount || 0);
  const investment = Number(inst?.investment_amount || 0);

  if (!investment) return 0;

  return +((amount / investment) * 100).toFixed(1);
}
getAmountMaxRatio(inst: any): number {
  const amountMax = Number(inst?.next_installment?.amount_max || 0);
  const investment = Number(inst?.investment_amount || 0);

  if (!investment) return 0;

  return +((amountMax / investment) * 100).toFixed(1);
}
getAmountPercentage(inst: any): number {
  const amount = Number(inst?.next_installment?.amount || 0);
  const investment = Number(inst?.investment_amount || 0);

  if (!investment) return 0;

  return +((amount / investment) * 100).toFixed(1);
}

getAmountMaxPercentage(inst: any): number {
  const amountMax = Number(inst?.next_installment?.amount_max || 0);
  const investment = Number(inst?.investment_amount || 0);

  if (!investment) return 0;

  return +((amountMax / investment) * 100).toFixed(1);
}

addPayment(id:any): void {
    console.log('id from addPayment' , id)
    this.router.navigate(['/add-payments/', id]);
  }


  getInvestmentRatio(inst: any): number {
  const installmentAmount = Number(inst?.next_installment?.amount || 0);
  const investmentAmount = Number(inst?.investment_amount || 0);

  if (!investmentAmount || investmentAmount === 0) {
    return 0;
  }

  return +((installmentAmount / investmentAmount) * 100).toFixed(1);
}


}
